import "core-js/modules/es.array.push.js";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
export default {
  name: "AdminOrdersSubMenusLinks",
  props: {
    loggedUserData: {
      type: Object,
      required: true
    },
    searchCriterias: {
      type: Object,
      required: false
    },
    isExternal: {
      type: Boolean,
      required: false,
      default: false
    },
    forceTab: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      selectedTab: null,
      tabs: {
        orders: "orders",
        sourcing: "sourcing",
        creditNote: "creditNote",
        inboundDeliveries: "inboundDeliveries",
        factoringProviders: "factoringProviders"
      },
      canAccessSourcing: false,
      canManageCreditNote: false,
      canManageFactoringProviders: false,
      canManageDeliveries: false
    };
  },
  created: function created() {
    this.selectedTab = this.$route.query.tab || this.tabs.orders;
    if (this.forceTab) {
      this.selectedTab = this.forceTab;
    }
    this.canAccessSourcing = hasRole(process.env.VUE_APP_ROLES_ACCESS_SOURCING);
    this.canManageCreditNote = isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_ORDER);
    this.canManageFactoringProviders = isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_FACTORING);
    this.canManageDeliveries = hasRole(process.env.VUE_APP_ROLES_MANAGE_DELIVERIES);
  },
  methods: {
    changeTab: function changeTab() {
      if (this.forceTab) {
        this.selectedTab = this.forceTab;
      }
      if (this.isExternal) {
        this.$router.push({
          name: "adminOrderList",
          query: {
            tab: this.$route.query.tab
          },
          force: true
        }).catch(function () {});
      }
      if (this.$route.query.tab) {
        this.$emit("tabChanged", this.$route.query.tab);
        this.selectedTab = this.tabs[this.$route.query.tab];
      } else if (this.selectedTab) {
        this.$emit("tabChanged", this.selectedTab);
        this.selectedTab = this.tabs[this.selectedTab];
      } else {
        this.selectedTab = this.tabs.orders;
      }
    },
    isAdminNotConsultant: isAdminNotConsultant
  },
  watch: {
    $route: function $route(oldRoute, newRoute) {
      if (oldRoute.query.tab !== newRoute.query.tab) {
        this.changeTab();
      } else {
        this.$router.go();
      }
    }
  }
};